module.exports = __webpack_public_path__ + "static/media/santa_katarina_thumb_even.4305edf2.jpg";